import { query } from '@organization/api'
import { Loading } from '@organization/components'
import {
  DashboardCharts,
  DashboardMedia,
  DashboardTasks
} from '@organization/features/dashboard/components'
import {
  ChartWidget,
  MediaWidget,
  TaskListWidget,
  Widget,
  WidgetFunctionProps
} from '@organization/features/dashboard/types'
import { useSessionContext } from '@shared/hooks'
import { useQuery } from '@tanstack/react-query'
import { Col, Flex, Row, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

const isWidgetOfType = (
  widget: Widget
): widget is ChartWidget & TaskListWidget & MediaWidget => {
  return widget.widget_type in widgetMapping
}

interface MediaTypesComponent {
  chart: React.FC<WidgetFunctionProps<ChartWidget>>
  task_list: React.FC<WidgetFunctionProps<TaskListWidget>>
  media: React.FC<WidgetFunctionProps<MediaWidget>>
}

export const widgetMapping: MediaTypesComponent = {
  chart: DashboardCharts,
  task_list: DashboardTasks,
  media: DashboardMedia
}

export const DashboardPage = () => {
  const { t } = useTranslation()
  const { user } = useSessionContext()

  const { data, isLoading } = useQuery({
    ...query.dashboard.getWidgetsById(user?.id),
    enabled: !!user?.id
  })

  return (
    <Flex vertical gap={20}>
      <Typography.Title level={4}>{t('dashboard.header')}</Typography.Title>

      {isLoading ? (
        <Loading />
      ) : (
        <Row gutter={[36, 36]}>
          {data?.map((widget, index) => {
            if (
              isWidgetOfType(widget) &&
              (widget.widget_type === 'chart' ||
                widget.widget_type === 'task_list' ||
                widget.widget_type === 'media')
            ) {
              const Component = widgetMapping[widget.widget_type]

              return (
                <Col key={index} xs={24} lg={12}>
                  <Component instance={widget} />
                </Col>
              )
            }
            return null
          })}
        </Row>
      )}
    </Flex>
  )
}
